import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { LiveGuideline } from '../../../redux/actions/liveGuidelineActions/types';
import { toShortLocalDate } from '../../../helpers/dateHelper';
import { BoldText, Text } from '../../../styles/common.styles';
import { blueLink, grayDark03 } from '../../../styles/colors';
import { Dropdown } from 'antd';
import {
    DotsAction,
    GuidelineLink,
    OpenMenuButton,
    ProductActionMenuItem,
} from './LiveGuidelinesList.styles';
import { ItemType } from 'antd/lib/menu/hooks/useItems';

export const getGuidelineActions = (canManageGuidelines: boolean): Array<ItemType> => {
    return [
        {
            key: 'ManageNotification',
            label: <ProductActionMenuItem>Manage subscription notifications</ProductActionMenuItem>,
        },
        {
            key: 'ExportToCSV',
            label: <ProductActionMenuItem>Export to CSV</ProductActionMenuItem>,
        },
        ...(canManageGuidelines
            ? [
                { type: 'divider' } as ItemType,
                {
                    key: 'Delete',
                    label: <ProductActionMenuItem>Delete</ProductActionMenuItem>,
                } as ItemType,
            ]
            : []),
    ];
};

const handleGuidelineAction = (
    key: string,
    guideline: LiveGuideline,
    onManageNotifications: (guideline: LiveGuideline) => void,
    onExportGuideline: (guideline: LiveGuideline) => void,
    onDeleteGuideline: (guideline: LiveGuideline) => void,
) => {
    switch (key) {
        case 'ManageNotification':
            onManageNotifications(guideline);
            break;
        case 'ExportToCSV':
            onExportGuideline(guideline);
            break;
        case 'Delete':
            onDeleteGuideline(guideline);
            break;
        default:
            break;
    }
};

export const columns = (
    onManageNotifications: (guideline: LiveGuideline) => void,
    onExportGuideline: (guideline: LiveGuideline) => void,
    onDeleteGuideline: (guideline: LiveGuideline) => void,
    canManageGuidelines: boolean,
): ColumnsType<LiveGuideline> => [
    {
        title: 'LIVE GUIDELINE',
        dataIndex: 'name',
        sorter: (a: LiveGuideline, b: LiveGuideline) => a.name.localeCompare(b.name),
        defaultSortOrder: 'ascend',
        width: 350,
        render: (value: string, record: LiveGuideline) => (
            <GuidelineLink to={`/live-guidelines/${record.id}`}>
                <Text weight={400} size={14} height={18} color={blueLink}>
                    {value}
                </Text>
            </GuidelineLink>
        ),
    },
    {
        title: 'PRODUCTS',
        dataIndex: 'productsCount',
        align: 'left',
        width: 100,
        render: (value: string, record: LiveGuideline) => (
            <GuidelineLink to={`/live-guidelines/${record.id}`}>
                <BoldText weight={700} size={13} color={blueLink} height={18}>
                    {value}
                </BoldText>
            </GuidelineLink>
        ),
    },
    {
        title: 'DATE CREATED',
        dataIndex: 'createdOn',
        width: 150,
        render: (value: string) => (
            <Text weight={400} size={13} height={16} color={grayDark03}>
                {toShortLocalDate(value)}
            </Text>
        ),
    },
    {
        title: 'OWNER',
        dataIndex: 'ownerNames',
        render: (value: string) => (
            <Text weight={400} size={12} height={16} color={grayDark03}>
                {value}
            </Text>
        ),
    },
    {
        title: 'ACTIONS',
        width: 20,
        onCell: () => ({ style: { textAlign: 'center' } }),
        render: (value: string, record: LiveGuideline) => (
            <Dropdown
                menu={{
                    items: getGuidelineActions(canManageGuidelines),
                    onClick: ({ key }) => {
                        handleGuidelineAction(
                            key,
                            record,
                            onManageNotifications,
                            onExportGuideline,
                            onDeleteGuideline,
                        );
                    },
                }}
                overlayClassName="projects-table-columns-dropdown"
                placement="bottomRight"
                trigger={['click']}
                onOpenChange={() => {}}
                disabled={false}
            >
                <div>
                    <OpenMenuButton>
                        <DotsAction></DotsAction>
                    </OpenMenuButton>
                </div>
            </Dropdown>
        ),
    },
];
